import React from 'react'
import PropTypes from 'prop-types'
import { StaggeredMotion, spring } from 'react-motion'

/**
 * Staggered Fade In
 */
export default function StaggeredFadeIn({
  numElements,
  stiffness,
  damping,
  children,
}) {
  return (
    <StaggeredMotion
      defaultStyles={new Array(numElements)
        .fill(null)
        .map(() => ({ opacity: 0 }))}
      styles={prevInterpolatedStyles =>
        prevInterpolatedStyles.map((_, i) => {
          return i === 0
            ? { opacity: spring(1, { stiffness, damping }) }
            : {
                opacity: spring(prevInterpolatedStyles[i - 1].opacity, {
                  stiffness,
                  damping,
                }),
              }
        })
      }
    >
      {interpolatingStyles =>
        typeof children === 'function'
          ? children(interpolatingStyles)
          : React.cloneElement(children, { interpolatingStyles })
      }
    </StaggeredMotion>
  )
}

StaggeredFadeIn.propTypes = {
  numElements: PropTypes.number.isRequired,
  stiffness: PropTypes.number,
  damping: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
}

StaggeredFadeIn.defaultProps = {
  stiffness: 170,
  damping: 26,
}
